import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TooltipContent } from '../../shared/shared.interface';


@Component({
	selector: 'kng-dialog-tooltip',
	templateUrl: './template/kng-dialog-tooltip.component.html',
	styleUrls: ['./template/kng-dialog-tooltip.component.scss']
})
export class KngDialogTooltipComponent implements OnInit 
{
	constructor(
        public dialogRef: MatDialogRef<KngDialogTooltipComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            state: TooltipContent;
            positionRelativeToElement: HTMLElement;
        }
	) { }

	matDialogConfig = new MatDialogConfig();
	ngOnInit(): void 
	{
  	this.updateTooltipPosition();
	}

    @HostListener('window:scroll') onScroll(): void 
	{
  	this.updateTooltipPosition();
	}

    updateTooltipPosition() 
    {
    	const rect: DOMRect =
            this.data?.positionRelativeToElement?.getBoundingClientRect();
    	if (rect) 
    	{
    		this.matDialogConfig.position = { top: `${rect.bottom + 2}px` };
    		this.dialogRef.updatePosition(this.matDialogConfig.position);
    	}
    }

    closeTooltip() 
    {
    	this.dialogRef.close();
    }
}
